import React from 'react';

interface ToggleChipProps {
  active: boolean;
  onToggle: () => void;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export default function ToggleChip({
  active,
  onToggle,
  icon,
  children,
  className = ""
}: ToggleChipProps) {
  return (
    <button
      type="button"
      onClick={onToggle}
      className={`
        inline-flex items-center gap-2 rounded-full border px-3 py-1.5 text-sm font-medium
        transition-all
        ${active
          ? 'bg-theme-primary/15 border-theme-primary text-white'
          : 'bg-theme-cards border-theme-cards text-theme-text-secondary hover:bg-theme-background/40'
        }
        ${className}
      `}
      aria-pressed={active}
    >
      {icon}
      {children}
    </button>
  );
}
